import { batch } from "react-redux";
import { SET_MARKET_PRICE, SET_LAST_PRICE, SET_BOD_PRICE, SET_BET } from "./types";
// import { getTickerType } from "../selectors";
import { getBodPrices } from "../../services/utility/utils";
import FeedAPI from "../../services/utility/datafeed/FeedAPI";

export const setCoinPrices =
  (data: any = {}) =>
  (dispatch) => {
    if (!data) return;
    data = JSON.parse(data);
    const {
      ts,
      from_sym: market,
      price,
      type,
      is_last,
      source = "moonrekt",
    } = data;

    if(market === "BTC") {
      dispatch({
        type: is_last || type === 'last' ? SET_LAST_PRICE : SET_MARKET_PRICE,
        payload: { ts, market, price, source },
      });
    }
    FeedAPI.updatePrice(market, data);
  };

export const fetchBodPrices = () => async (dispatch) => {
  const data = await getBodPrices();
  batch(() =>
    data.forEach((payload) =>
      dispatch({
        type: SET_BOD_PRICE,
        payload,
      })
    )
  );
};


export const setBet = (payload:any)=>(dispatch)=>{
   return dispatch({
    type:SET_BET,
    payload
  })
}